import { Component, h, Host, Element, Prop, Watch, State, Listen } from '@stencil/core';

let dropdownIdCounter = 0;
@Component({
  tag: 'wdf-menu-dropdown',
  shadow: false,
})
export class MenuDropdown {
  @Element() el!: HTMLElement;

  @Prop() label!: string;
  @Prop() linkList!: string;
  @Prop() urlList!: string;
  @Prop() isbuttonstyle: boolean = false;
  
  @State() innerLinkList: string[] = [];
  @State() innerUrlList: string[] = [];
  @State() labelCharacters = 0;
  @State() isOpen = false;


  private dropdown?: HTMLElement;
  
  private dropdownId: string;

  @Listen('menuHidden', { target: 'document' })
  handleMenuHidden() {
    this.closeDropdown();
    this.isOpen = false;
  }

  constructor() {
    this.transitionEndHandler = this.transitionEndHandler.bind(this);
    this.handleClick = this.handleClick.bind(this);
    dropdownIdCounter++;
    this.dropdownId = `dropdown-${dropdownIdCounter}`;
  }

  componentWillLoad() {
    this.parseLinkList();
  }

  @Watch('linkList')
  @Watch('urlList')
  parseLinkList() {
    if (this.linkList) this.innerLinkList = JSON.parse(this.linkList);
    if (this.urlList) this.innerUrlList = JSON.parse(this.urlList);

    const longest = Math.max(Math.max(...this.innerLinkList.map(item => item.length), this.label.length), 12);
    this.labelCharacters = longest < 12 ? 12 : (longest > 15 ? longest - 1 : (longest > 20 ? longest - 3 : longest));
  }

  componentDidLoad() {
    this.dropdown = this.el.querySelector('[data-dropdown]');
    window.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    window.removeEventListener('click', this.handleClick);
  }

  handleClick(e: Event) {
    if (this.isOpen && !this.el.contains(e.target as Node)) {
      this.closeDropdown();
    }
  }

  openDropdown() {
    this.isOpen = true;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  @Watch('isOpen')
  async watchOpen(newValue: boolean) {
    if (newValue) {
      await new Promise(resolve => setTimeout(resolve, 1));
    }
  
    if (this.dropdown) {
      const t = this.transitionEndHandler;
      this.dropdown.removeEventListener('transitionend', t);
      if (newValue) {
        this.dropdown.classList.remove('hidden');
        requestAnimationFrame(() => (this.dropdown.classList.add('opacity-100'), this.dropdown.addEventListener('transitionend', t)));
      } else {
        requestAnimationFrame(() => (this.dropdown.addEventListener('transitionend', t), this.dropdown.classList.remove('opacity-100')));
      }
    }
  }
  
  transitionEndHandler = (event: TransitionEvent) => {
    if (event.target === this.dropdown) {
      this.dropdown.classList.toggle('hidden', !this.isOpen);
      this.dropdown.removeEventListener('transitionend', this.transitionEndHandler);
    }
  };

  
  render() {

    // list of classes for not isButtonStyle
    const notButtonUl = "flex font-bold text-gray absolute gap-26 flex-col pt-28 pb-48 px-36 bg-white overflow-x-visible whitespace-nowrap top-[71px] before:content-[''] before:w-full before:-top-8 before:bg-white before:left-0 before:h-16 before:absolute";
    const buttonUl = "flex font-bold absolute gap-12 py-12 flex-col bg-gray left-0 right-0 top-[42px] px-5 rounded-b-3xl transition-all duration-200 ";
    const { isOpen, innerLinkList, innerUrlList, labelCharacters, label, isbuttonstyle } = this;
    const isOpenClass = isOpen ? 'opacity-100' : '';
    return (
      <Host class={`block ${isOpenClass}`}>
        <div
          role="button"
          aria-haspopup="true"
          aria-expanded={isOpen ? 'true' : 'false'}
          onClick={() => (isOpen ? this.closeDropdown() : this.openDropdown())}
        >
          <input
            id={this.dropdownId} 
            type="checkbox"
            checked={isOpen}
            class={`absolute w-full peer z-30 top-0 right-0 bottom-0 left-0 opacity-0`}
          />
          <label
            htmlFor={this.dropdownId}
            id="label"
            class={`flex self-center gap-8 transition-all duration-100
            ${isbuttonstyle && isOpen  ? 'rounded-t-3xl drop-shadow-lg' : ''}
            ${isbuttonstyle && !isOpen  ? 'rounded-3xl' : ''}
  

  
            ${isbuttonstyle ? 'bg-gray text-white px-5' : 'border-b-2 hover:border-b peer-hover:border-b-silver-15 peer:border-b-transparent'}
             ${isOpen && !isbuttonstyle ? 'peer-hover:border-b-silver-15' : ''} 
             ${isOpen && !isbuttonstyle ? 'peer-hover:peer-checked:border-b-red peer-checked:border-b-red peer-checked:[&>span]:text-gray' : ''
            } peer-focus-visible:outline peer-focus-visible:outline-black peer-focus-visible:outline-2 peer-focus-visible:outline-offset-4 border-transparent items-center 
            ${ isOpen ? 'peer-checked:[&>svg]:rotate-180 peer-checked:[&>#chevron]:-rotate-180' : ''
            }`}
          >
            <span class="whitespace-nowrap min-w-min h-full py-[10px]">{label}</span>
            <svg class="h-12 w-[14px] transition-all duration-175 ease-in " id="chevron" aria-hidden="true">
              <use class="arrow-right" xlinkHref="/assets/spritemap.svg#chevron-down" />
            </svg>
          </label>
        </div>
        <div
          data-dropdown
          class={`absolute opacity-0 hidden transition-all duration-75 ease-in-out z-20 w-full -translate-y-0 ${!isbuttonstyle ? '-translate-x-36' :''} ${!isOpen ? '-translate-y-6 ' : ''} ${isOpen && isbuttonstyle ? 'drop-shadow-md' : ''}  `}
          aria-hidden={!isOpen}
          aria-labelledby="label"
        >
          <ul
            class={` ${isbuttonstyle ? buttonUl : notButtonUl}`}
            role="menu"
          >
            {innerLinkList && innerLinkList.length ? (
              innerLinkList.map((link, index) => (
                <li class={`flex flex-col ${!isbuttonstyle ? 'text-gray' :'text-white '}`} key={index}>
                  <a
                    href={innerUrlList && innerUrlList[index] ? innerUrlList[index] : '#'}
                    class="border-b-2 border-transparent hover:border-silver-15 transition-colors duration-175 py-8 w-inherit w-full"
                    role="menuitem"
                    style={{ width: `${!isbuttonstyle? labelCharacters + 'ch': ''}` }} 
                  >
                    {link}
                  </a>
                </li>
              ))
            ) : (
              <li class="text-gray">
                <a class="py-8" role="menuitem">No links available</a>
              </li>
            )}
          </ul>
        </div>
      </Host>
    );
  }
}